const main = () => {
    if (!document.querySelector("#page-contact")) return;

    const typeCheckboxes = document.querySelectorAll('input[name="type[]"]');
    const visitDatetimeFields = document.querySelectorAll(
        ".js-visit-datetime-field"
    );
    const STORE_VISIT_TYPE_VALUE = "1"; // 店舗来店のご予約

    // 初期状態で非表示にする（ちらつき防止）
    visitDatetimeFields.forEach((field) => {
        field.style.display = "none";
    });

    // 来店日時フィールドの表示/非表示を切り替える関数
    const toggleVisitDatetimeFields = () => {
        const isStoreVisitSelected = Array.from(typeCheckboxes).some(
            (checkbox) =>
                checkbox.checked && checkbox.value === STORE_VISIT_TYPE_VALUE
        );

        visitDatetimeFields.forEach((field) => {
            field.style.display = isStoreVisitSelected ? "" : "none";
        });
    };

    // 各チェックボックスにイベントリスナーを追加
    typeCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener("change", toggleVisitDatetimeFields);
    });

    // 初期状態をチェック（既にチェックされている場合に表示）
    toggleVisitDatetimeFields();
};

export default main;
